var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguageBubble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "57px",
    height: "59px",
    viewBox: "0 0 57 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0BFF01AF-602E-4AC5-8502-51BCC8219116") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.-what-can-help",
    transform: "translate(-885.000000, -484.000000)",
    strokeWidth: 2.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(887.000000, 486.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.314495,40.623315 L48.726645,40.623315 C51.489345,40.623315 53.749545,38.363115 53.749545,35.600565 L53.749545,5.022765 C53.749545,2.260215 51.489345,1.5e-05 48.726645,1.5e-05 L5.022945,1.5e-05 C2.260245,1.5e-05 4.5e-05,2.260215 4.5e-05,5.022765 L4.5e-05,35.600565 C4.5e-05,38.363115 2.260245,40.623315 5.022945,40.623315 L12.003945,40.623315 L12.003945,55.443165 L25.314495,40.623315",
    id: "Stroke-1",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.883045,
    y1: 34.470975,
    x2: 26.883045,
    y2: 6.659475,
    id: "Stroke-3",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.7973,
    y1: 20.517015,
    x2: 15.14175,
    y2: 20.517015,
    id: "Stroke-5",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.798545,6.523065 C25.798545,6.523065 12.654795,18.576165 25.798545,34.435365",
    id: "Stroke-7",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9696,6.523065 C27.9696,6.523065 41.11335,18.576165 27.9696,34.435365",
    id: "Stroke-9",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.344225,29.339175 C33.549825,27.057675 26.770575,24.547725 18.481575,28.296525",
    id: "Stroke-11",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.455705,11.641665 C33.636855,13.969215 26.681505,16.602765 18.168555,12.607815",
    id: "Stroke-13",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.89465,20.50764 C40.89465,28.25049 34.6176,34.52724 26.8752,34.52724 C19.1319,34.52724 12.85485,28.25049 12.85485,20.50764 C12.85485,12.76449 19.1319,6.48789 26.8752,6.48789 C34.6176,6.48789 40.89465,12.76449 40.89465,20.50764 Z",
    id: "Stroke-15",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-17",
    stroke: "#222456",
    points: "12.0039 40.623315 12.0039 55.443165 25.31445 40.623315"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageBubble);
export default __webpack_public_path__ + "static/media/languageBubble.a9a83922.svg";
export { ForwardRef as ReactComponent };